import { observer } from "mobx-react-lite";

import { useTheme } from "@bps/fluent-ui";
import { useStores } from "@stores/hooks/useStores.ts";
import { withFetch } from "@ui-components/data-fetcher/DataFetcher.tsx";

import { ClaimStatusBadgeBaseProps } from "./ClaimStatusBadge.types.ts";
import { ClaimStatusBadgeTooltip } from "./ClaimStatusBadgeTooltip.tsx";
import { ClaimStatusCompactBadge } from "./ClaimStatusCompactBadge.tsx";
import { ClaimStatusIconBadge } from "./ClaimStatusIconBadge.tsx";
import { ClaimStatusStandardBadge } from "./ClaimStatusStandardBadge.tsx";
import { mapToClaimBadgeProps } from "./utils.tsx";

const ClaimStatusBadgeBase: React.FC<ClaimStatusBadgeBaseProps> = observer(
  props => {
    const { acc } = useStores();
    const theme = useTheme();

    const mappedProps = props.mapToBadgeProps
      ? props.mapToBadgeProps(props, theme, acc)
      : mapToClaimBadgeProps(props, theme, acc);

    if (props.compactMode) {
      return (
        <ClaimStatusBadgeTooltip {...props}>
          <ClaimStatusCompactBadge
            {...mappedProps}
            compactMode={props.compactMode}
            claimId={props.claimId}
          />
        </ClaimStatusBadgeTooltip>
      );
    }

    if (mappedProps.displayIcon) {
      return (
        <ClaimStatusBadgeTooltip {...props}>
          <ClaimStatusIconBadge {...mappedProps} />
        </ClaimStatusBadgeTooltip>
      );
    }

    return (
      <ClaimStatusBadgeTooltip {...props}>
        <ClaimStatusStandardBadge {...mappedProps} />
      </ClaimStatusBadgeTooltip>
    );
  }
);

export const ClaimStatusBadge = withFetch(
  x => [
    x.acc.ref.claimStatuses.load(),
    x.acc.ref.claimAdjustmentStatuses.load()
  ],
  ClaimStatusBadgeBase
);
